import { render, staticRenderFns } from "./CopyRun.vue?vue&type=template&id=068c772e&"
import script from "./CopyRun.vue?vue&type=script&lang=js&"
export * from "./CopyRun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports